module.exports = __webpack_public_path__ + "static/media/expo.ee304a4f.jpg";